import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  const handleNavClick = (path, sectionId = null) => {
    if (sectionId && window.location.pathname === '/') {
      const element = document.querySelector(sectionId);
      if (element) {
        const offsetTop = element.offsetTop - 80;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        });
      }
    } else {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/NestedInfo.jpeg"
                alt="NestedInfo Logo"
                className="w-12 h-12 object-contain rounded-xl"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/48x48?text=N';
                }}
              />
              <span className="text-2xl font-bold">Nested<span className="text-blue-500">Info</span></span>
            </Link>
            <p className="text-gray-400 leading-relaxed">
              We transform businesses through innovative technology solutions. Your partner in digital success.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-green-500 hover:text-white transition-all">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-blue-500 hover:text-white transition-all">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-purple-500 hover:text-white transition-all">
                <i className="fab fa-github"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-400 hover:bg-pink-500 hover:text-white transition-all">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-xl font-bold text-white">Quick Links</h4>
            <div className="space-y-3">
              <button 
                onClick={() => handleNavClick('/', '#home')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-home mr-2"></i> Home
              </button>
              <button 
                onClick={() => handleNavClick('/services')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-cogs mr-2"></i> Services
              </button>
              <button 
                onClick={() => handleNavClick('/about')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-info-circle mr-2"></i> About Us
              </button>
              <button 
                onClick={() => handleNavClick('/portfolio')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-briefcase mr-2"></i> Portfolio
              </button>
              <button 
                onClick={() => handleNavClick('/team')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-users mr-2"></i> Team
              </button>
              <button 
                onClick={() => handleNavClick('/contact')}
                className="block text-gray-400 hover:text-green-500 transition-colors"
              >
                <i className="fas fa-phone mr-2"></i> Contact
              </button>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-xl font-bold text-white">Services</h4>
            <div className="space-y-3">
              <a href="#" className="block text-gray-400 hover:text-green-500 transition-colors">Web Development</a>
              <a href="#" className="block text-gray-400 hover:text-green-500 transition-colors">Mobile Apps</a>
              <a href="#" className="block text-gray-400 hover:text-green-500 transition-colors">Cloud Solutions</a>
              <a href="#" className="block text-gray-400 hover:text-green-500 transition-colors">AI & ML</a>
              <a href="#" className="block text-gray-400 hover:text-green-500 transition-colors">Cybersecurity</a>
            </div>
          </div>

          <div className="space-y-6">
            <h4 className="text-xl font-bold text-white">Newsletter</h4>
            <p className="text-gray-400">Stay updated with our latest news and technologies.</p>
            <div className="space-y-3">
              <input 
                type="email" 
                placeholder="Your email" 
                className="w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-green-500"
              />
              <button className="w-full bg-green-500 text-white px-4 py-3 rounded-lg font-semibold hover:bg-green-600 transition-all">
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} NestedInfo. All rights reserved.
            </div>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-green-500 transition-colors">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-green-500 transition-colors">Terms of Service</a>
              <a href="#" className="text-gray-400 hover:text-green-500 transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;